import i18n from "src/i18n";

import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

type SelectedLanguage = {
  selectedLanguage: string;
};
const initialState: SelectedLanguage = {
  selectedLanguage: i18n.language,
};

type userSliceReducer<Payload> = CaseReducer<
  SelectedLanguage,
  PayloadAction<Payload>
>;

const userSelectedLanguage: userSliceReducer<{
  active_language: string;
}> = (state, action) => {
  state.selectedLanguage = action.payload.active_language;
};

export const userSlice = createSlice({
  initialState,
  name: "user",
  reducers: {
    userSelectedLanguage,
  },
});

export default userSlice;
